import { memo } from 'react'

import { SVGProps } from '../types/iconType'

export const MailIcon = memo(({ className, style }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 2.083H3c-1.657 0-3 1.33-3 2.97v9.895c0 1.64 1.343 2.969 3 2.969h14c1.657 0 3-1.33 3-2.97V5.053c0-1.64-1.343-2.969-3-2.969zm-.41 1.98L10.71 9.88a1.005 1.005 0 0 1-1.42 0L3.41 4.062h13.18zM18 14.947c0 .546-.448.99-1 .99H3c-.552 0-1-.444-1-.99v-9.49l5.88 5.819a3.022 3.022 0 0 0 4.24 0L18 5.457v9.49z"
        fillRule="evenodd"
      />
    </svg>
  )
})
